import { MODE, API_URL_DEV, API_URL_PRO, TIME_EXPIRED_TRIES } from "../config";
import { SOURCE } from "../constants/constants";

class Request {
  constructor() {
    this.mode = MODE;
    this.api_url = this.mode === "LOCALHOST" ? API_URL_DEV : API_URL_PRO;
  }

  getSource() {
    return "internacional";
  }

  callTracking(elementName, elementLocation, msisdn, offerId, requestId, beneficiaryMsisdn = '', customSource) {
    return fetch(`${this.api_url}saveTracking/`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-portalservicios-uname": msisdn
      },
      body: JSON.stringify({
        offerId,
        elementName: elementName,
        elementLocation: elementLocation,
        source: customSource ? customSource : SOURCE,
        userAgent: navigator.userAgent,
        msisdn,
        requestId,
        beneficiaryMsisdn
      }),
    });
  }

  isUsaNumber(number, name, offerId, offerAuxId, pkgType) {
    let source = this.getSource();
    return fetch(
      `${this.api_url}anonymous/help/offer/1${number}?callerName=${name}&country=usa&requestSource=${source}&offerId=${offerId}&offerAuxId=${offerAuxId}&pkgType=${pkgType}`,
      {
        method: "GET",
        headers: {
          "X-Data-ProductId": pkgType,
        },
      }
    )
      .then((response) => response.json())
      .catch(function (error) {
        throw error;
      });
  }

  setTries(number) {
    let source = this.getSource();
    return fetch(
      `${this.api_url}offer/${source}/${TIME_EXPIRED_TRIES}/${source}/${number}/attempts`,
      {
        method: "post",
      }
    )
      .then((res) => res.json())
      .catch(function (error) {
        console.log("Hubo un problema con la petición Fetch:" + error.message);
      });
  }

  getTries(number) {
    let source = this.getSource();
    return fetch(`${this.api_url}offer/${source}/${source}/${number}/attempts`)
      .then((res) => res.json())
      .catch(function (error) {
        console.log("Hubo un problema con la petición Fetch:" + error.message);
      });
  }
}

export default Request;
